import React from "react";
import { Link } from "react-router-dom";
import Section from "../Section";

const VerificationError = ({ type }) => {
  const title = "Sorry!";
  const text =
    type === "bvn"
      ? "We could not retrieve your BVN details. You can attempt the verification again"
      : "We could not retrieve your NIN details. You can attempt the verification again";

  const linkTo =
    type === "bvn" ? "/bvn-verification-start" : "/nin-verification-start";
  const linkText =
    type === "bvn" ? "Restart BVN Verification" : "Restart NIN Verification";

  return (
    <Section title={title} text={text}>
      <Link className="btn w-100 btn-primary mb-3" to={linkTo} replace>
        {linkText}
      </Link>
      <Link className="btn w-100 btn-outline-primary" to="/" replace>
        Back to Home
      </Link>
    </Section>
  );
};

export default VerificationError;
